<template>
  <div class="container_box details_box_styles">
    <!--轮播图-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005067') }}</h2>
        </template>
        <Form :label-width="80" @submit.native.prevent>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Row class="rotation_item" v-for="(ele,index) in rotationList" :key="index">
                  <h2 class="mt5 mb5">{{ ele.rotationTitle }}</h2>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="$t('key1005042')" class="required_style_label">
                      <div class="jump_box">
                        <span class="jump_text" v-if="ele.jumpTargetName" :title="ele.jumpTargetName">{{ ele.jumpTargetName }}</span>
                        <span class="not_filled_text" v-else>{{ $t('key1005048') }}</span>
                        <Button type="primary" size="small" class="ml15" @click="replaceBtn(ele, index)">
                          {{ ele.jumpTargetName ? $t('key1005043') : $t('key1000669') }}
                        </Button>
                      </div>
                    </Form-item>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <FormItem class="required_style_label" :label-width="0">
                      <Upload
                        style="width: 450px;"
                        type="drag"
                        name="files"
                        :headers="headObj"
                        :action="fileApi"
                        :data="uploadData"
                        :show-upload-list="false"
                        :on-success="(value) => handelUploadSuccess(value, item, index)"
                        :format="['jpg', 'jpeg', 'png', 'gif', 'bmp']"
                        :max-size="20480"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize">
                        <div class="img_style" v-if="ele['imagePath_' + item.code]">
                          <img style="width: 100%; height: auto; display: inline-block" :src="setImgPath(ele['imagePath_' + item.code])" alt=""/>
                        </div>
                        <div v-else>
                          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                          <p class="upload_txt">
                            <span>{{ $t('key1005046') }}</span>
                            <span class="tips_txt">{{ $t('key1005117') }}</span>
                          </p>
                        </div>
                      </Upload>
                    </FormItem>
                  </Col>
                  <div class="wp100 flex justify-content-end">
                    <Button type="error" size="small" class="mb20" @click="deleteBtn(ele, index)" :disabled="rotationList.length<=1">{{ $t('key1005118') }}</Button>
                  </div>
                </Row>
              </template>
            </template>
          </languagesTabs>
          <Button type="primary" @click="addRotationBtn">{{ $t('key1005119') }}</Button>
        </Form>
      </Card>
    </div>
    <!--效果预览-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005049') }}</h2>
        </template>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <div class="rotationChart_box" v-if="rotationList.length>0">
                <Carousel
                  ref="myCarousel"
                  :autoplay="setting.autoplay"
                  :autoplay-speed="setting.autoplaySpeed"
                  :dots="setting.dots"
                  :radius-dot="setting.radiusDot"
                  :trigger="setting.trigger"
                  :loop="setting.loop"
                  :arrow="setting.arrow">
                  <CarouselItem v-for="(ele,index) in rotationList" :key="index">
                    <div class="banner_img_box">
                      <img class="banner_img" v-if="ele['imagePath_' + item.code]" :src="setImgPath(ele['imagePath_' + item.code])" @error="setErrorImg($event)"/>
                      <div v-else class="design_sketch_styles"> {{ $t('key1005044') + (index + 1) }}</div>
                    </div>
                  </CarouselItem>
                </Carousel>
              </div>
            </template>
          </template>
        </languagesTabs>
      </Card>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <Button class="mr15" @click="rotationChartCancelBtn">{{ $t('key1000112') }}</Button>
      <Button class="mr15" v-if="getPermission('ymsAdvertisement_save') || getPermission('ymsAdvertisement_update')"
        type="primary" @click="rotationChartBtn">{{ $t('key1000555') }}</Button>
    </div>
    <!--更换活动弹窗设置-->
    <clickJumpModal ref="clickJump" @updateData="updateData"></clickJumpModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import clickJumpModal from "@/views/yms/components/marketingManage/clickJumpModal";
import languagesTabs from "@/components/common/languagesTabs.vue";
import {isJSON} from "@/utils/common";

export default {
  name: "rotationChart",
  mixins: [Mixin],
  data() {
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      setting: {
        autoplay: false,
        autoplaySpeed: 4000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always',
        loop: false
      },
      ymsAdvertisementId: null,
      currentIndex: null,
      rotationList: [
        {rotationTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005116'), jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''}
      ],
      advertisementTitle: ''
    };
  },
  created() {
    this.systemDefaultLanguage().then(() => {
      this.initMultilingualImgFields();
    });
    this.ymsAdvertisementId = this.$route.query.ymsAdvertisementId || null;
    if (this.ymsAdvertisementId) {
      this.getDetailsData();
    }
  },
  methods: {
    // 初始化多语种图片的数据字段
    initMultilingualImgFields() {
      if (this.multilingualNamesList.length > 0) {
        this.multilingualNamesList.map((item) => {
          this.rotationList.map((ele) => {
            ele['imagePath_' + item.code] = '';
          });
        });
        this.$forceUpdate();
      }
    },
    // 获取详情数据
    getDetailsData() {
      let v = this;
      v.rotationList = [];
      v.axios.get(api.get_ymsAdvertisement_detail + `${v.ymsAdvertisementId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.ymsAdvertisementDetailBos;
          v.advertisementTitle = data.advertisementTitle;
          if (list.length > 0) {
            list.map((item, index) => {
              let obj = {
                rotationTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005114') + (index + 1),
                jumpTargetType: item.jumpTargetType,
                jumpTargetValue: item.jumpTargetValue,
                jumpTargetName: item.jumpTargetName || ''
              };
              let imgObj = {};
              let objs = '';
              let imagePath = item.imagePath || '';
              if (imagePath) {
                if (isJSON(imagePath)) {
                  objs = JSON.parse(imagePath);
                } else {
                  objs = imagePath;
                }
              }
              v.multilingualNamesList.map((ele) => {
                imgObj['imagePath_' + ele.code] = objs[ele.code] || '';
              });
              v.rotationList.push(Object.assign({}, obj, imgObj));
            });
            v.$forceUpdate();
          }
        }
      });
    },
    // 上传图片成功
    handelUploadSuccess(response, item, index) {
      let v = this;
      if (response.code === 0) {
        let url = response.datas[0];
        let key = 'imagePath_' + item.code;
        v.$set(v.rotationList[index], key, url);
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005038'));
        v.$forceUpdate();
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005039'));
      }
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 添加轮播项
    addRotationBtn(item) {
      let currentIndex = this.rotationList.length + 1;
      let obj = {rotationTitle: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005114')}${currentIndex}`, imagePath: '', jumpTargetType: null, jumpTargetValue: '', jumpTargetName: ''};
      this.rotationList.push(obj);
      this.$forceUpdate();
    },
    // 更换活动
    replaceBtn(item, index) {
      this.currentIndex = index;
      this.$refs['clickJump'].initFun(item);
    },
    // 删除轮播项
    deleteBtn(item, index) {
      this.rotationList.splice(index, 1);
      this.$forceUpdate();
    },
    // 取消按钮
    rotationChartCancelBtn() {
      this.$router.push('/advertisingManage');
    },
    // 保存按钮
    rotationChartBtn() {
      let v = this;
      let url = '';
      let method = '';
      let query = {
        advertisementTitle: v.advertisementTitle,
        orientationType: 1,
        status: 1, // 默认启用
        ymsAdvertisementDetailBos: []
      };
      if (v.ymsAdvertisementId) {
        url = api.put_ymsAdvertisement_update;
        method = 'put';
        query.ymsAdvertisementId = v.ymsAdvertisementId;
      } else {
        url = api.post_ymsAdvertisement_save;
        method = 'post';
      }
      // 校验上传图片、点击跳转活动
      for (let i = 0; i < v.rotationList.length; i++) {
        let item = v.rotationList[i];
        let obj = {};
        for (let j = 0; j < v.multilingualNamesList.length; j++) {
          let ele = v.multilingualNamesList[j];
          if (!item['imagePath_' + ele.code] && ele.code === 'zh-CN') {
            v.$Message.warning(`${ele.title}${item.rotationTitle}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005115')}`);
            return false;
          }
          obj[ele.code] = item['imagePath_' + ele.code] || '';
          item.imagePath = JSON.stringify(obj);
        }
        if (item.jumpTargetType !== 3) {
          if (!item.jumpTargetValue) {
            v.$Message.warning(`${item.rotationTitle}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005037')}`);
            return false;
          }
        }
        query.ymsAdvertisementDetailBos.push({
          imagePath: item.imagePath,
          jumpTargetType: item.jumpTargetType,
          jumpTargetValue: item.jumpTargetValue,
          jumpTargetName: item.jumpTargetName,
          sortNo: i + 1
        });
      }
      v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.rotationChartCancelBtn();
        }
      });
    },
    // 获取更换活动的设置参数
    updateData(data) {
      let v = this;
      if (data) {
        let jumpTargetType = data.jumpTargetType;
        v.rotationList.map((item, index) => {
          if (index === v.currentIndex) {
            item.jumpTargetName = data.jumpTargetValue || '';
            // 活动
            if (jumpTargetType === 0) {
              data.activityList.map((ele) => {
                if (ele.ymsActivityPlanId === data.jumpTargetValue) {
                  item.jumpTargetName = ele.activityTitle;
                }
              });
            }
            // 分类
            else if (jumpTargetType === 2) {
              data.ymsProductCategoryList.map((ele) => {
                if (ele.ymsProductCategoryId === data.jumpTargetValue) {
                  item.jumpTargetName = ele.title;
                }
              });
            }

            item.jumpTargetType = data.jumpTargetType;
            item.jumpTargetValue = data.jumpTargetValue;
          }
        });
        v.$forceUpdate();
      }
    },
  },
  components: {
    languagesTabs,
    clickJumpModal
  }
};
</script>

<style lang="less" scoped>
.basic_information_box {
  .rotation_item {
    border-bottom: 1px solid #e8eaec;
    margin-bottom: 25px;

    .upload_txt {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .tips_txt {
        color: #d00707;
        font-size: 12px;
      }
    }

    .img_style {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 664px;
      max-height: 324px;
      min-height: 100px;
    }

    .jump_box {
      display: flex;
      align-items: center;
      position: relative;
      top: 2px;

      .jump_text {
        display: inline-block;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 285px;
        font-size: 12px;
      }

      .not_filled_text {
        font-size: 12px;
        display: inline-block;
        color: #d00707;
      }
    }
  }

  .rotationChart_box {
    width: 644px;
    height: 324px;
    cursor: pointer;
    margin-bottom: 55px;
    background: #FFFFFF;

    /deep/ .ivu-carousel {
      width: 644px;
      height: 100%;

      .banner_img_box {
        width: 644px;
        height: 324px;
        background-color: #F7F7F7;
        overflow: hidden;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .banner_img {
          display: inline-block;
          width: 100%;
          height: auto;
        }

        .design_sketch_styles {
          color: #333;
          font-size: 17px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .ivu-carousel-dots-inside {
        bottom: 18px;
      }

      .radius {
        width: 8px;
        height: 8px;
      }

      .ivu-carousel-active {
        .radius {
          background-color: #FD5425;
        }
      }

      .ivu-carousel-arrow {
        width: 24px;
        height: 32px;
        background: #000000;
        opacity: 0.4;
        display: flex;
        justify-content: center;
        align-items: center;

        .ivu-icon {
          font-size: 22px;
          color: #fff;
        }
      }

      .ivu-carousel-arrow.right {
        right: 0;
        border-radius: 4px 0px 0px 4px;
      }

      .ivu-carousel-arrow.left {
        border-radius: 0px 4px 4px 0px;
        left: 0;
      }
    }
  }
}

.options_content {
  box-shadow: 0px -3px 10px 0px #c9cbce;
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}

</style>